module.exports = __webpack_public_path__ + "media/src/ui/icons/icon_pen_new_white-dcc146e12706ee5222ab0058f89ea3e9.svg";